import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';
import { usesDashFormVariant } from '../../utils/formVariant';

class SelectButton extends React.Component {
  render() {
    const { buttonText, selected, onClick, morphism = true, variant } = this.props;
    const useDash = morphism && usesDashFormVariant(variant);

    if (useDash) {
      return (
        <button
          type="button"
          onClick={() => onClick()}
          className={`lex-dash-segmented__btn${selected ? ' is-active' : ''}`}
        >
          {buttonText}
        </button>
      );
    }

    if (morphism) {
      const className = ['lex-chip', selected ? 'lex-chip--selected' : ''].filter(Boolean).join(' ');
      return (
        <button type="button" onClick={() => onClick()} className={className}>
          {selected && (
            <Icon name="check" size={14} color={semantic.primary.text.label} solid />
          )}
          {buttonText}
        </button>
      );
    }

    return (
      <button
        onClick={() => onClick()}
        className={selected ? 'select_button_primary' : 'select_button_secondary'}
        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <div>{buttonText}</div>
        <div className="checkmark_icon" />
      </button>
    );
  }
}

export default SelectButton;
